import request, { miniFetch } from '../../lib/api/request.js';

// 登录一：首页打开Scratch时，自动获取一次用户登录信息
const requestSession = (resolve, reject) => request(resolve, reject, '/user/getSession');
// 登录二：提交账号、密码进行登录
const requestLoginByEmailAndUserName = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v2/user/login',
        method: 'post',
        mode: 'cors',
        data: data
    });
};
// 手机号登录
const requestLogin = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/login',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

// 获取用户信息
const requestUserInfo = function(resolve, reject) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/getUserInfo',
        method: 'get',
        mode: 'cors'
    });
};
// 获取邮箱验证码
const requestEmailCode = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/email/code',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

// 请求手机验证码
const requestMobileCode = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/sms/code',
        method: 'post',
        mode: 'cors',
        data: data
    });
};
// 邮箱注册
const requestEmailRegister = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/registerByEmail',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

const requestRegister = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/register',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

// 忘记密码
const requestForget = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/forget',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

// 忘记密码通过邮箱找回
const requestForgetByEmail = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/forgetByEmail',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

// 注销账号
const requestRemoveAccount = function(resolve, reject) {
    return miniFetch(resolve, reject, {
        url: '/v1/user/removeAccount',
        method: 'post',
        mode: 'cors'
    });
};


// 修改用户信息
const requestUpdateAccount = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/user',
        method: 'put',
        mode: 'cors',
        data: data
    });
};


// 退出：提交账号，退出登录状态
const requestLogout = (resolve, reject, data) => request(resolve, reject, '/user/logout', { body: data });
// 获取项目源代码
const requestProject = (resolve, reject, projectId) => request(resolve, reject, `/scratch/project/${projectId}`);
// 保存标题
const requestSaveProjectTitle = (resolve, reject, projectId, projectTitle) => {
    request(resolve, reject, '/scratch/saveProjcetTitle', { body: `id=${projectId}&title=${projectTitle}` });
};
// 保存缩略图
const requestSaveProjectThumbnail = (resolve, reject, projectId, thumbnailBlob) => {
    request(resolve, reject, `/scratch/thumbnail/${projectId}`, {
        body: thumbnailBlob,
        headers: { 'Content-Type': 'image/png' }
    });
};
// 保存分享
const requestShareProject = (resolve, reject, projectId) => {
    request(resolve, reject, `/scratch/shareProject/${projectId}`);
};

export {
    requestSession,
    requestLoginByEmailAndUserName,
    requestUserInfo,
    requestEmailCode,
    requestEmailRegister,
    requestRegister,
    requestLogout,
    requestProject,
    requestSaveProjectTitle,
    requestSaveProjectThumbnail,
    requestShareProject,
    requestForget,
    requestForgetByEmail,
    requestLogin,
    requestMobileCode,
    requestRemoveAccount,
    requestUpdateAccount
};